import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";
import { Home } from "@App/Pages/Partner/RaiffeisenImpulsDe/Home";
import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";
import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";

export function RaiffeisenImpulsDe() {
  const { config } = useOrganizationConfig();

  return (
    <DefaultRoutes
      layout={
        <DefaultPartnerLayout
          logos={config.navbar.logos}
          backToPartnerButton={config.navbar.backToPartnerButton}
        />
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
